import { RouteRecordRaw } from 'vue-router';
import Dashboard from './dashboard.vue';


let routes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        meta: { sideMenuLabel: "Dashboard" },
        component: () => import("./views/dashboard.vue"),
    },
    {
        path: '/dashboard/:userIdentifier',
        meta: { title: "Dashboard utente", routeBuster: true },
        component: () => import("./views/dashboardUser.vue"),
    },
    {
        path: '/dashboard/commissions/:userIdentifier',
        name: 'dashboard_commissions',
        component: () => import("@/views/commission/views/commissions.vue")
    },
    {
        path: '/dashboard/walletTransactions/:userIdentifier',
        name: 'dashboard_walletTransactions',
        component: () => import("@/views/walletTransaction/views/walletTransactions.vue")
    },
];

export default routes;